<div class="row">
  <div class="col-md-5">
    <app-lessons></app-lessons>
  </div>
  <div class="col-md-7">
    <router-outlet></router-outlet>
  </div>
</div>

